import {sortWithLabel} from '../utils/sort/comparators/labelComparator'
import {HeaderLink} from './headerLinks'

export const sortHeaderLinks = (headerLinks: HeaderLink[]): HeaderLink[] => {
  return sortWithLabel(headerLinks)
}
